import Alpine from 'alpinejs'
import * as animate from '@js/util/animate.js'

Alpine.data('animate', (method, ...args) => {
  return animate[method](...args)
})
